var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneric({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags/generic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#878E9F",
    fillRule: "nonzero",
    cx: 42,
    cy: 42,
    r: 42
  }), /*#__PURE__*/React.createElement("g", {
    id: "All-currency-symbol",
    transform: "translate(26.000000, 27.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7813613,15.3751836 C27.7813613,19.6082834 25.5230296,23.519829 21.8570576,25.636379 C18.1910856,27.7529289 13.6744218,27.7529289 10.0084498,25.636379 C6.34247779,23.519829 4.08414604,19.6082834 4.08414604,15.3751836 C4.08414604,8.83137827 9.38894837,3.52657594 15.9327537,3.52657594 C22.476559,3.52657594 27.7813613,8.83137827 27.7813613,15.3751836 L27.7813613,15.3751836 Z",
    id: "path2170",
    strokeWidth: 5.87760105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.476526,6.740629 L0.7018,0.273845 L7.476526,6.740629 Z",
    id: "path3145",
    strokeWidth: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.721285,6.894599 L31.188069,0.119873 L24.721285,6.894599 Z",
    id: "path3147",
    strokeWidth: 6.19999981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.496011,30.760113 L24.721285,24.293329 L31.496011,30.760113 Z",
    id: "path3149",
    strokeWidth: 6.19999981
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.393858,30.914084 L6.860642,24.139358 L0.393858,30.914084 Z",
    id: "path3151",
    strokeWidth: 6.19999981
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.cc6328c3f8f795014aeafefa16403c73.svg";
export { ForwardRef as ReactComponent };